export const cssVarColors = {
	// text-on-surface etc.
	onSurface:    '#464646',   // deep charcoal for body copy

	// primary brand accent (a deep “Government of Canada” navy)
	primary:      '#002F6C',   // dark navy
	primaryLight: '#336699',   // lighter sky-blue

	// highlights (maple-leaf red)
	highlight:          '#D80621',  // Pantone 032 C → hex #D80621
	highlightAlternate: '#AD051A',  // ~20% darker red
	highlightAlpha:     'rgba(216, 6, 33, 0.08)',

	// surfaces
	surface:          '#FFFFFF',  // white
	surfaceAlternate: '#F2F2F2',  // very light gray
}
